import logger from '@eventbrite/client-logger';
import { CheckoutErrorName } from '@eventbrite/checkout-postmessage-api';
import { logEvent } from '@eventbrite/statsig';
import { change } from 'redux-form';
import { CustomSubmissionError } from '@eventbrite/redux-form-tools';
import {
    ERROR_CONTACT_INFO_INCOMPLETE,
    ERROR_EXPRESS_CHECKOUT_ORDER,
} from '../../../constants/expressCheckout';
import { STATSIG_EVENT_NAMES } from '../../../constants/statsig';
import { getIsContactInformationComplete } from '../../../selectors/forms';
import { submitCheckoutForm } from '../../checkout';
import {
    CHECKOUT_FORM_NAME,
    TICKETS_FULL_SIZE_PATH,
    TICKETS_PAGE_FORM_NAME,
} from '../../../constants';
import {
    trackExpressCheckoutClicked,
    trackOrderSubmit,
    trackPaymentMethodSelect,
} from '../../eventAnalytics';
import { resetOrderToken as resetOrderTokenAction } from '../../tokens';
import { resetOrderAction } from '../actions';
import { getPaymentMethodAndNonceFromPaymentData } from '../../../utils/expressCheckout';
import { notifyParentOrderPlacingError } from '../../notifyParent';
import { handleCaptchaBeforeCreateOrder } from './handleCaptchaBeforeCreateOrder';

/**
 * Dispatch the correct actions when the ApplePay payment is authorised, so that create and place order requests happen
 */
export const createAndPlaceOrderExpressCheckout =
    (payment) => async (dispatch, getState) => {
        const { nonce, paymentMethod } =
            getPaymentMethodAndNonceFromPaymentData(payment);

        logEvent(STATSIG_EVENT_NAMES.CHECKOUT_STEP_PLACE_ORDER_CLICK);
        dispatch(trackExpressCheckoutClicked(TICKETS_FULL_SIZE_PATH));

        dispatch(change(TICKETS_PAGE_FORM_NAME, nonce, null));

        if (!getIsContactInformationComplete(getState())) {
            dispatch(
                notifyParentOrderPlacingError(
                    CheckoutErrorName.ERROR_CONTACT_INFO_INCOMPLETE,
                ),
            );

            throw new CustomSubmissionError(
                {
                    _error: ERROR_CONTACT_INFO_INCOMPLETE,
                },
                {},
            );
        }

        try {
            await dispatch(handleCaptchaBeforeCreateOrder(false));

            dispatch(
                change(CHECKOUT_FORM_NAME, 'paymentMethod', paymentMethod),
            );

            dispatch(trackPaymentMethodSelect(paymentMethod));

            dispatch(trackOrderSubmit(paymentMethod, false));

            await dispatch(submitCheckoutForm({}));
        } catch (e) {
            logger.error(e);

            dispatch(resetOrderAction());
            dispatch(resetOrderTokenAction());

            dispatch(
                notifyParentOrderPlacingError(
                    CheckoutErrorName.ERROR_EXPRESS_CHECKOUT_ORDER,
                ),
            );

            throw new CustomSubmissionError(
                {
                    _error: ERROR_EXPRESS_CHECKOUT_ORDER,
                },
                {},
            );
        }
    };
